import { render, staticRenderFns } from "./featured-product-card.vue?vue&type=template&id=ffbeb766&scoped=true&lang=pug&"
import script from "./featured-product-card.vue?vue&type=script&lang=coffee&"
export * from "./featured-product-card.vue?vue&type=script&lang=coffee&"
import style0 from "./featured-product-card.vue?vue&type=style&index=0&id=ffbeb766&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbeb766",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CraftVisual: require('/opt/build/repo/node_modules/@bkwld/cloak/components/craft-visual.coffee').default,SmartLink: require('/opt/build/repo/nuxt-app/components/globals/smart-link.coffee').default,ProductBadges: require('/opt/build/repo/nuxt-app/components/globals/product/product-badges.vue').default,ProductReviewsBadge: require('/opt/build/repo/nuxt-app/components/globals/product/reviews-badge.vue').default,ProductPrice: require('/opt/build/repo/nuxt-app/components/globals/product/price.vue').default,Btn: require('/opt/build/repo/nuxt-app/components/globals/btn/btn.vue').default})
